var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAiflow = function SvgAiflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 643.59 478.18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Aiflow_svg__cls-1",
    d: "M289.34 0ZM556.1 242.18v99.27a50.22 50.22 0 0 1-50.22 50.22h-1a50.21 50.21 0 0 1-50.22-50.22s.75-133.8.48-178.41c-.52-84.57-57.58-127.89-74.88-138.26C360.8 13.12 333.85.05 291.7 0c-87.77 0-158.16 74-158.18 161.23l-.4 185.45a45 45 0 0 1-45 45H76.59C28.82 391.68 0 430.4 0 478.18h99.62a120 120 0 0 0 120-120V158.75c-.05-34.56 31.14-72.18 72.22-72.22h4c43.72 1.27 72.26 36.69 72.21 76.22l.1 178.21a137.22 137.22 0 1 0 274.44 0V155.68a86.5 86.5 0 0 0-86.49 86.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Aiflow_svg__cls-1",
    x: 555.1,
    y: 0.03,
    width: 88.49,
    height: 86.5,
    rx: 43.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "Aiflow_svg__cls-1",
    x: 248.09,
    y: 239.61,
    width: 88.49,
    height: 86.5,
    rx: 43.25
  })));
};
export default SvgAiflow;